// import { twMerge } from 'tailwind-merge';

// import { CellRendererParams } from '@/components/DataGrid/column';
import { cn } from '~/lib/cn';

import type { ColDef } from '../../components/DataGrid/types';
import type { IgnoreMark } from '../../types';
import { listFormatter, numberFormat, zeroFormatter } from './renderers';
// type Ephimeral = keyof TrackRollupRow;

// // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// const OptTerrRenderer = (deliveredCountField: TrackRollupRowKey, missedCountField: TrackRollupRowKey) => {
//   // eslint-disable-next-line react/display-name
//   return (p: CellRendererParams<Partial<TrackRollupRow>>): string | number | JSX.Element | null => {
//     if (!p?.data) return null;
//     const deliveryTerritoryCount = (p.data[deliveredCountField] as number) ?? 0;
//     const missedTerritoriesCount = (p.data[missedCountField] as number) ?? 0;
//     const rightsTerritories = deliveryTerritoryCount + missedTerritoriesCount;
//     return (
//       <>
//         <span
//           className={twMerge(
//             deliveryTerritoryCount === rightsTerritories ? 'text-green-500' : '',
//             deliveryTerritoryCount < rightsTerritories ? 'text-red-500' : '',
//             missedTerritoriesCount >= 25 ? 'text-red-500 font-bold' : '',
//           )}
//         >
//           {deliveryTerritoryCount}
//         </span>
//         <span className="font-light mx-1">/</span>
//         <span>{rightsTerritories}</span>
//       </>
//     );
//   };
// };

export const columnDefs: ColDef[] = [
  // {
  //   field: 'hashKey',
  //   headerName: 'ID',
  //   flex: 1,
  //   sortable: true,
  //   hide: true,
  // },
  {
    field: 'artist',
    headerName: 'Artist',
    width: 300,
    sortable: true,
    hide: false,
  },
  {
    field: 'cleanTitle',
    headerName: 'Clean Title',
    width: 300,
    sortable: true,
    hide: false,
    cellRenderer: (p) => {
      if (!p?.data) {
        return null;
      }

      const cleanTitle = p.data?.cleanTitle as string;
      const isIgnored = p.data?.itemIgnore as IgnoreMark;

      return (
        <span
          data-testid="clean-title"
          className={cn(isIgnored && 'line-through text-subtle')}
          title={
            isIgnored
              ? `Ignored by ${isIgnored.owner.name} since ${isIgnored.createdAt.toLocaleDateString()}`
              : undefined
          }
        >
          {cleanTitle}
        </span>
      );
    },
  },
  // {
  //   field: 'trackTitleCleaned',
  //   headerName: 'Track Title Cleaned',
  //   width: 120,
  //   sortable: true,
  //   hide: true,
  // },
  // {
  //   field: 'mediaCode',
  //   headerName: 'Media Code',
  //   width: 120,
  //   sortable: true,
  //   hide: false,
  // },
  // {
  //   field: 'isImmersive',
  //   headerName: 'Is Immersive',
  //   width: 120,
  //   sortable: true,
  //   hide: false,
  // },
  // {
  //   field: 'latestProductTs',
  //   headerName: 'Update Date',
  //   width: 120,
  //   sortable: true,
  //   hide: true,
  //   valueFormatter: dateFormatter,
  // },
  {
    field: 'isrcList',
    headerName: 'ISRC List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: false,
  },
  {
    field: 'gpidList',
    headerName: 'GPID List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: false,
  },
  {
    headerName: 'WMG1 Label',
    field: 'wmg1Labels',
    hide: true,
  },
  {
    field: 'majorLabelList',
    headerName: 'Major Label List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: false,
  },
  {
    field: 'presentationLabelList',
    headerName: 'Presentation Label List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: false,
  },
  {
    field: 'repertoireOwnerList',
    headerName: 'Repertoire Owner List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'deliveryTerritoryList',
    headerName: 'Delivery Territory List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'deliveryTerritoryCount',
    headerName: '# Delivery Terr',
    flex: 1,
    hide: true,
  },
  {
    field: 'trackRightsTerritoryList',
    headerName: 'Track Rights Territory List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'shortTitleList',
    headerName: 'Short Title List',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  // {
  //   field: 'majorGenreDescList',
  //   headerName: 'Major Genre List',
  //   flex: 1,
  //   valueFormatter: listFormatter,
  //   hide: true,
  // },
  // {
  //   field: 'rollUpTitleList',
  //   headerName: 'Roll Up Title List',
  //   flex: 1,
  //   valueFormatter: listFormatter,
  //   hide: true,
  // },
  // {
  //   field: 'wtdStreams',
  //   headerName: 'WTD Streams',
  //   flex: 1,
  //   valueFormatter: zeroFormatter,
  //   hide: true,
  //   sortable: true,
  // },
  {
    field: 'lastCompleteWeekStreams',
    headerName: 'Streams #: Last Complete Week',
    flex: 1,
    valueFormatter: zeroFormatter,
    hide: true,
    sortable: true,
  },
  // {
  //   field: 'mtdStreams',
  //   headerName: 'MTD Streams',
  //   flex: 1,
  //   valueFormatter: zeroFormatter,
  //   hide: true,
  //   sortable: true,
  // },
  // {
  //   field: 'ytdStreams',
  //   headerName: 'YTD Streams',
  //   flex: 1,
  //   valueFormatter: zeroFormatter,
  //   hide: true,
  //   sortable: true,
  // },

  // {
  //   field: '_appleTerritoryCount' as Ephimeral,
  //   headerName: 'KPI: Apple Delivery',
  //   width: 140,
  //   cellRenderer: OptTerrRenderer('appleTerritoryCount', 'missedAppleTerritoriesCountAlt'),
  //   colDependsOn: ['appleTerritoryCount', 'missedAppleTerritoriesCountAlt'],
  //   sortable: true,
  //   hide: true,
  // },
  // {
  //   field: '_spotifyTerritoryCount' as Ephimeral,
  //   headerName: 'KPI: Spotify Delivery',
  //   width: 140,
  //   cellRenderer: OptTerrRenderer('spotifyTerritoryCount', 'missedSpotifyTerritoriesCountAlt'),
  //   colDependsOn: ['spotifyTerritoryCount', 'missedSpotifyTerritoriesCountAlt'],
  //   sortable: true,
  //   hide: true,
  // },
  // {
  //   field: '_deliveryTerritoryCount' as Ephimeral,
  //   headerName: 'KPI: Delivery',
  //   width: 140,
  //   cellRenderer: OptTerrRenderer('deliveryTerritoryCount', 'missedTerritoriesCountAlt'),
  //   colDependsOn: ['deliveryTerritoryCount', 'missedTerritoriesCountAlt'],
  //   sortable: true,
  //   hide: true,
  // },
  {
    field: 'missedTerritoriesCountAlt',
    headerName: '# Missed Terr.',
    width: 120,
    sortable: true,
    hide: true,
  },
  {
    field: 'missedTerritoriesAlt',
    headerName: 'Missed Terr.',
    flex: 1,
    valueFormatter: listFormatter,
    hide: true,
  },
  {
    field: 'missedAppleTerritoriesCountAlt',
    headerName: 'Apple: # Missed Terr.',
    width: 120,
    sortable: true,
    hide: true,
  },
  {
    field: 'missedAppleTerritoriesAlt',
    headerName: 'Apple: Missed Terr.',
    valueFormatter: listFormatter,
    flex: 1,
    hide: true,
  },
  {
    field: 'appleTerritoryCount',
    headerName: 'Apple: # Terr.',
    width: 140,
    sortable: true,
    hide: true,
  },
  {
    field: 'missedSpotifyTerritoriesCountAlt',
    headerName: 'Spotify: # Missed Terr.',
    width: 120,
    sortable: true,
    hide: true,
  },
  {
    field: 'missedSpotifyTerritoriesAlt',
    headerName: 'Spotify: Missed Terr.',
    valueFormatter: listFormatter,
    flex: 1,
    hide: true,
  },
  {
    field: 'spotifyTerritoryCount',
    headerName: 'Spotify: # Terr.',
    width: 140,
    sortable: true,
    hide: true,
  },
  {
    field: 'projectedMissedStreams',
    colDependsOn: ['projectedMissedStreamsAlt', 'projectedMissedStreamsIgnore'],
    headerName: 'Projected missed streams',
    // valueFormatter: zeroFormatter,
    width: 120,
    sortable: true,
    hide: true,
    cellRenderer: (p) => {
      if (!p?.data) {
        return null;
      }

      const projectedMissedStreams = numberFormat(
        (p.data?.projectedMissedStreams as number) ?? 0,
      );
      const isIgnored = p.data?.itemIgnore as IgnoreMark;

      return (
        <div
          title={
            isIgnored
              ? `Ignored by ${isIgnored.owner.name} since ${isIgnored.createdAt.toLocaleDateString()}`
              : undefined
          }
        >
          <span className={cn(isIgnored ? 'line-through text-subtle' : '')}>
            {projectedMissedStreams}
          </span>
          {isIgnored ? ' → 0' : null}
        </div>
      );
    },
  },
];
